import { render } from "./autopricesettingView.vue?vue&type=template&id=ee4be9d8&scoped=true"
import script from "./autopricesettingView.vue?vue&type=script&lang=js"
export * from "./autopricesettingView.vue?vue&type=script&lang=js"

import "./autopricesettingView.vue?vue&type=style&index=0&id=ee4be9d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee4be9d8"]])

export default __exports__